module.exports = __webpack_public_path__ + "media/images/aboutus/SAPC5456_3-31f00cd1e1ca8f1873f6ae4cf527314a.png";